<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout-content">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>business</md-icon>
            </div>
            <h4 class="title">View Workplace</h4>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item"><b>Name:</b><span>{{ workplace.name }}</span></div>
              <div class="md-layout-item"><b>Workpoint Port</b><span>{{ workplace.display_name }}</span></div>
              <div class="md-layout-item"><b>Item Number:</b><span>{{ workplace.item_number }}</span></div>
              <div class="md-layout-item"><b>Location:</b><span v-html="workplace.location"></span>
              </div>
            </div>
            <hr/>
            <div class="md-layout">
              <div class="md-layout-item"><b>Current Status:</b> <span
                  :class="[workplace.status=='Created'?'text-primary':(workplace.status=='Grounded'?'text-danger':(workplace.status=='Under Maintenance'?'text-warning':(workplace.status=='Operational'?'text-success':'')))]">{{
                  workplace.status
                }}</span>
              </div>
              <div class="md-layout-item">
                <md-button @click="goBack" class="md-primary md-dense">
                  Back to List
                </md-button>

              </div>
            </div>

          </md-card-content>
        </md-card>
      </div>
    </div>


    <div class="md-layout-item md-size-100">
      <nav-tabs-card>
        <template slot="content">
          <md-tabs class="md-info" md-alignment="left">
            <md-tab id="tab-home" md-label="Statues" md-icon="hourglass_empty">
              <div class="md-layout">
                <div class="md-layout-item md-size-75">
                  <md-table>
                    <md-table-row>
                      <md-table-head>
                        Date
                      </md-table-head>
                      <md-table-head>
                        Status
                      </md-table-head>
                      <md-table-head>
                        Remarks
                      </md-table-head>
                      <md-table-head>
                        Created By

                      </md-table-head>
                    </md-table-row>
                    <template v-if="statuses.length > 0">
                      <md-table-row v-for="(status) in statuses"
                                    :class="[status.name=='Created'?
                                    'text-primary':(status.name=='Grounded'?
                                    'text-danger':(status.name=='Under Maintenance'?
                                    'text-warning':(status.name=='Operational'?'text-success':'')))]"
                      :key="'status'+status.id">
                        <md-table-cell>{{ new Date(status.created_at).toLocaleDateString() }}</md-table-cell>
                        <md-table-cell>{{ status.name }}</md-table-cell>
                        <md-table-cell>{{ status.reason }}</md-table-cell>
                        <md-table-cell>{{ status.creator ? status.creator.name : '' }}</md-table-cell>
                      </md-table-row>
                    </template>
                  </md-table>
                </div>
                <div class="md-size-25 md-layout-item">
                  <template v-if="allPermissions">
                    <h4>
                      <md-icon>settings</md-icon>
                      Status Settings
                    </h4>
                    <div v-if="allPermissions.includes('operational-workplace-status') ||
                                 allPermissions.includes('under-maintenance-workplace-status') ||
                                 allPermissions.includes('grounded-workplace-status')">
                      <div v-if="allPermissions.includes('operational-workplace-status')">
                        <md-radio v-model="workplace.status" value="Operational"
                                  @change="setStatus('Operational')"><span
                            class="text-success"> Operational</span></md-radio>
                      </div>
                      <div v-if="allPermissions.includes('under-maintenance-workplace-status')">
                        <md-radio v-model="workplace.status" value="Under Maintenance"
                                  @change="setStatus('Under Maintenance')"><span
                            class="text-warning">Under Maintenance</span></md-radio>
                      </div>
                      <div v-if="allPermissions.includes('grounded-workplace-status')">
                        <md-radio v-model="workplace.status" value="Grounded" @change="setStatus('Grounded')"><span
                            class="text-danger">Grounded</span></md-radio>
                      </div>
                    </div>
                    <div v-else>
                      <p class="text-danger">You are not authorized to change status</p>
                    </div>
                  </template>

                </div>
              </div>
            </md-tab>
            <md-tab id="tab-activities" md-label="Activities" md-icon="assignment">
              <workplace-activity-table v-if="workplace.id"
                                        :workplace="workplace"
                                        :tableData="workplace.activities?workplace.activities:[]"
                                        @add:activity:workplace="showAddActivityModal"
                                        @removeActivity="deleteActivityRow"
              />
            </md-tab>
          <md-tab id="tab-labourer" md-label="Labourer" md-icon="pdf">
            <general-table :table-data="workplace.activityLabourers?workplace.activityLabourers:[]"
                           :model="workplace"
                           type="Labourer Activity"
                           list-type="Labourer Activity"
                           :table-columns="activityLabourerWorkplacesColumns"
                           :dynamicStatusColumn="'status'"
                           :statusClassMap="{Assigned: 'success','Unsigned': 'danger',pending: 'warning',Rejected: 'warning'}"
                           @removeRow="deleteActivityLabourerWorkplace"
                           @addNewItem="showActivityLabourerWorkplaceForm"
            ></general-table>
            </md-tab>
          </md-tabs>
        </template>
      </nav-tabs-card>
    </div>
    <add-activity-modal
        :title="'Add Activities to '+workplace.name"
        :showModal="showActivityForm"
        @closeModal="hideActivityModal"
        @add:activity="addActivity"
    ></add-activity-modal>
    <add-activity-labourer-workplace-modal
        :title="'Add Labourer to '+workplace.name"
        :showModal="showActivityLabourerWorkplaceForm"
        model="Labourer"
        :workplace="workplace"
        modelType="activityLabourerWorkplace/list"
        @closeModal="hideActivityLabourerWorkplaceModal"
        @addParents="addActivityLabourerWorkplace"
    ></add-activity-labourer-workplace-modal>


    <modal v-if="modal.classicModal" @close="classicModalHide">
      <template slot="header">
        <h4 class="modal-title">Change status</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button"
                   @click="classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <div slot="body" v-if="allPermissions">
        <div>

          <p>You are about to change the status of this item. Are you sure? if yes, Fill the remarks
            below
            then click change button</p>

          <form @submit.prevent="updateStatus">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-field class="md-invalid">
                    <md-input v-model="status.reason" placeholder="Reason/Remarks"/>
                    <validation-error :errors="apiValidationErrors.reason"/>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <md-button @click="updateStatus" class="md-primary md-dense">
              Change
            </md-button>
          </form>

        </div>


        <template slot="footer">
          <md-button class="md-danger md-simple" @click="classicModalHide">Close</md-button>
        </template>
      </div>
    </modal>
  </div>


</template>

<script>
import formMixin from '@/mixins/form-mixin';
import { Modal, NavTabsCard, ValidationError } from '@/components';
import Vuex from 'vuex';
import WorkplaceActivityTable from '@/pages/settings/workplaces/components/WorkplaceActivitiesTable.vue';
import AddActivityModal from '@/pages/settings/workplaces/components/AddActivityModal.vue';
import GeneralTable from '@/components/Tables/GeneralTable.vue';
import AddActivityLabourerWorkplaceModal
    from '@/pages/settings/workplaces/components/AddActivityLabourerWorkplaceModal.vue';

export default {
    components: {
        AddActivityLabourerWorkplaceModal,
        GeneralTable,
        AddActivityModal,
        WorkplaceActivityTable,
        NavTabsCard,
        Modal,
        ValidationError
    },
    mixins: [formMixin],
    data () {
        return {
            showActivityModal: false,
            showActivityForm: false,
            workplace: {
                type: 'workplaces',
                name: null,
                item_number: null,
                location: null,
            },
            workplaceData: {},
            statuses: [],
            status: {
                name: null,
                reason: null,
            },
            modal: {
                classicModal: false,
            },
            allPermissions: [],
            showActivityLabourerWorkplaceForm: false,
            activityLabourerWorkplacesColumns: ['activity.name', 'labourer.name',  'start_date', 'end_date'],
        };
    },

    created () {
        this.get();
    },
    methods: {
        classicModalHide: function () {
            this.modal.classicModal = false;
        },
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('workplaces/get', id);
                this.workplace = this.$store.getters['workplaces/workplace'];
                this.statuses = this.workplace.statuses;
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        goBack () {
            this.$router.push({ name: 'Workplaces List' });
        },
        setStatus (value) {
            this.status.name = value;
            this.modal.classicModal = true;
        },
        async updateStatus () {
            try {
                this.workplaceData = {
                    type: 'workplaces',
                    id: this.workplace.id,
                    status: { name: this.status.name, reason: this.status.reason },
                };
                console.log(this.workplaceData);
                await this.$store.dispatch('workplaces/updateStatus', this.workplaceData);
                await this.$store.dispatch(
                    'alerts/success',
                    'Workplace status updated successfully.'
                );
                this.$router.go();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        addActivityToWorkplace () {

        },

        showAddActivityModal () {
            console.log('activity form on');
            this.showActivityForm = true;
        },
        hideActivityModal () {
            this.showActivityForm = false;
        },
        async addActivity (new_activity) {
            try {
                let activityIds = this.workplace.activities.map(p => p.id);
                let updateNeeded = false;
                for (const activity of new_activity) {
                    if (!activityIds.includes(activity.id)) {
                        activity.status = 'active';
                        this.workplace.activities.push(activity);
                        updateNeeded = true;
                        let aw = {
                            type: 'activityWorkplaces',
                            workplace_id: this.workplace.id,
                            activity_id: activity.id,
                        };
                        try {
                            await this.$store.dispatch('activityWorkplaces/add', aw);
                            this.notifySuccess('Activity added successfully.');
                        } catch (e) {
                            this.notifyException(e);
                        }
                    } else {
                        this.$store.dispatch(
                            'alerts/error',
                            `Oops, Activity "${activity.name}" already on the list!`
                        );
                    }
                }
                if (updateNeeded) {
                    await this.update();
                }

                this.hideActivityModal();
                this.new_permission = [];
            } catch (e) {
                console.log(e);
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        async update () {
            try {
                await this.$store.dispatch('workplaces/update', this.workplace);
                await this.$store.dispatch(
                    'alerts/success',
                    'Workplace updated successfully.'
                );
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        deleteActivityRow (item) {
            let indexToDelete = this.workplace.activities.findIndex(
                tableRow => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                this.workplace.activities.splice(indexToDelete, 1);
                this.update();
            }
        },

        deleteActivityLabourerWorkplace (item) {
            let indexToDelete = this.workplace.activityLabourers.findIndex(
                tableRow => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                this.workplace.activityLabourers.splice(indexToDelete, 1);
                this.update();
            }
        },
        hideActivityLabourerWorkplaceModal () {
            this.showActivityLabourerWorkplaceForm = false;
        },
        async addActivityLabourerWorkplace (new_parent) {
            try {
                this.workplace.activityLabourers.push(new_parent);
                this.hideActivityLabourerWorkplaceModal();
                new_parent = {};
            } catch (e) {
                this.notifyException(e);
            }
        },
    },
    computed: {

        ...Vuex.mapState({
            me: state => state.profile.me
        }),
    },
    watch: {
        me: {
            handler: function (val) {
                if (val) {
                    this.roles = val.roles.map(r => r.name);
                    this.allPermissions = val.allPermissions.map(p => p.name);
                }
            },
            deep: true,
            immediate: true
        },
    }
};

</script>
